import { Box, Flex, Spinner } from '@chakra-ui/react'
import { FC } from 'react'
import { images } from 'constant/images'

/**
 * Loading molecules
 * Nền ảnh dashboard mờ + lớp phủ bán trong suốt, không nhìn rõ nội dung
 * @constructor
 */
export const Loading: FC = () => {
  return (
    <Flex
      alignItems="center"
      height="100vh"
      justifyContent="center"
      overflow="hidden"
      position="relative"
      width="100%"
    >
      {/* Lớp nền: ảnh dashboard + blur */}
      <Box
        backgroundImage={`url(${images.LOADING_BACKGROUND})`}
        backgroundPosition="center"
        backgroundSize="cover"
        filter="blur(16px) saturate(0.7)"
        height="100%"
        left={0}
        position="absolute"
        top={0}
        transform="scale(1.1)"
        width="100%"
      />
      {/* Lớp phủ bán trong suốt để giảm độ rõ nội dung */}
      <Box
        bg="blackAlpha.600"
        height="100%"
        left={0}
        position="absolute"
        top={0}
        width="100%"
      />
      {/* Spinner nổi trên cùng */}
      <Spinner color="white.base" position="relative" size="xl" zIndex={1} />
    </Flex>
  )
}
